<template>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-img
          contain
          v-on="on"
          :src="src"
          :alt="name"
          v-bind="attrs"
          :width="`${size}px`"
          :height="`${size}px`"
          class="d-inline-block ma-4"
        ></v-img>
      </template>
      <span>{{name}}</span>
    </v-tooltip>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: "SkillLogo",
  props: {
    src: {
      type: String,
      required: false,
      default: undefined,
    },
    name: {
      type: String,
      required: false,
      default: undefined,
    },
    size: {
      type: Number,
      required: false,
      default: 96,
    },
  },
});
</script>
